import React from 'react';
import { MarkButton } from '../../../components/MarkControls';
import formatDuration from '../../../utils/formatDuration';
import type { ActivityStep } from '../../../types';
import StepCardFrame from './StepCardFrame';
import * as styles from './journey.module.css';
const ACTIVITY_LABELS = {
    send_email: 'Send email',
    send_sms: 'Send SMS',
    external_action: 'External action'
};
type Props = { step: ActivityStep; onEditTemplate?: (stepId: string) => void };
const ActivityCard: React.FC<Props> = ({ step, onEditTemplate }) => (
    <StepCardFrame
        id={step.id}
        title={ACTIVITY_LABELS[step.activity] ?? step.activity}
        kind={
            step.activity === 'send_email'
                ? 'email'
                : step.activity === 'send_sms'
                  ? 'sms'
                  : 'action'
        }
        action={
            onEditTemplate && step.activity !== 'external_action' ? (
                <MarkButton compact onClick={() => onEditTemplate(step.id)}>
                    Edit template
                </MarkButton>
            ) : undefined
        }
    >
        <p className={styles.description}>
            {step.wait_for
                ? `Wait ${formatDuration(step.wait_for)} before this step`
                : 'No step delay'}
        </p>
    </StepCardFrame>
);
export default ActivityCard;
